<template>
  <v-form :readonly="readonly">
    <v-row>
      <v-col>
        <!-- Табы  -->
        <v-card class="mb-2">
          <v-card-title> Оценка экономических последствий </v-card-title>
          <v-card-text>
            <EconomicTable
              :value="data"
              :readonly="readonly"
              @change="doChangeEconomic"
              @blur="doBlur"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { SHORT_NAME_LENGTH } from '@/store/const/expDefaults'
import { copyObject } from '@/lib/objects'
import ls from '@/lib/localStorageUtils'
import EconomicTable from '@/components/expSummary/summaryScore/comp/EconomicTable.vue'
import { ASSESSMENT_ORGANIZATION_DEFAULT } from '@/components/expAssessment/const'

export default {
  components: { EconomicTable },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    onCreate: {
      type: Function,
      default: null,
    },
    dictType: {
      type: String,
      default: undefined,
    },
  },
  data: () => ({
    renderComponent: true,
    economicAssessment: null,
    data: null,
    dataLoaded: false,
    dt: undefined, //dictType
    newExpertiseName: '',
    activeTab: 0,
    disabledTab: false,
    answerYear: ls.load('answerYear'),
  }),
  async mounted() {
    await this.syncFromValue()
  },
  watch: {
    value: 'reInit',
    readonly: 'reInit',
  },
  computed: {
    ...mapGetters([
      'subExpertiseUUID',
      'versionList',
      'versionListReady',
    ]),
    needCreateVersion() {
      return this.versionListReady && !this.versionList?.length
    },
    canPersistInitial() {
      return !!(this.subExpertiseUUID || this.needCreateVersion)
    },
    shortNameLength() {
      return SHORT_NAME_LENGTH
    },
  },
  methods: {
    ...mapActions(['LOAD_ANSWERS', 'GET_PLP_REPORT']),
    ...mapMutations(['SET_TEMPLATE_CRITERION']),
    forceRender() {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    initNewData() {
      return copyObject(ASSESSMENT_ORGANIZATION_DEFAULT())
    },
    normalizeAssessmentData(raw) {
      if (!raw || typeof raw !== 'object') {
        return copyObject(ASSESSMENT_ORGANIZATION_DEFAULT())
      }
      const out = copyObject(raw)
      if (!Array.isArray(out.economic) || !out.economic.length) {
        const defaults = copyObject(ASSESSMENT_ORGANIZATION_DEFAULT())
        out.economic = defaults.economic
        if (out.maxValue == null) out.maxValue = defaults.maxValue
      }
      out.economic.forEach((item, index) => {
        item.idx = index + 1
      })
      return out
    },
    async syncFromValue() {
      const hasValue = this.value != null && typeof this.value === 'object'
      this.data = this.normalizeAssessmentData(hasValue ? this.value : null)
      if (hasValue) this.dataLoaded = true

      if (
        !this.readonly &&
        this.onCreate &&
        !hasValue &&
        this.canPersistInitial
      ) {
        const created = await this.onCreate(this.initNewData())
        this.data = this.normalizeAssessmentData(created || this.initNewData())
        if (this.value != null && typeof this.value === 'object') {
          this.dataLoaded = true
        }
      }
    },
    reInit() {
      if (this.readonly) {
        this.data = this.normalizeAssessmentData(this.value)
        return
      }
      const hasValue = this.value != null && typeof this.value === 'object'
      if (hasValue && !this.dataLoaded) {
        this.data = this.normalizeAssessmentData(this.value)
        this.dataLoaded = true
      } else if (!hasValue && !this.data) {
        this.data = this.normalizeAssessmentData(null)
      }
    },
    doChangeEconomic(data, force = false) {
      this.data = data
      this.doChange(force)
    },
    doChange(force = false) {
      if (!this.readonly) {
        this.$emit('change', this.data, force)
      }
    },
    doBlur() {
      this.$emit('blur')
    },
  },
}
</script>

<style scoped></style>
